// @flow
import React from 'react';
import { LongArrowRight } from '@finect/tabular-icons/longArrowRight';
import { getSuperPartnerBaseURL } from '@finect/front-utils/env';
import styled from 'styled-components';
import { Button as CoreButton } from '@finect/tabular-core/Button';
import { getFont } from '@finect/tabular-utils/getFont';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { H4 } from '@finect/tabular-core/Headings';
import { LayerLink } from '@finect/front-core/Links';

const Inner = styled.div`
  width: 32%;
  ${({ empty = false }) => empty && 'visibility: hidden;'};

  ${maxMediaQueries.desktop`
    ${({ empty = false }) => empty && 'display: none;'};
    width: 48%;
    `};

  ${maxMediaQueries.phone`
    width: 100%;
  `};

  height: 275px;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;

  color: #fff;
  background: ${({ img }) => (img ? `url(${img})` : '#fff')} no-repeat center center;
  background-size: cover;
  background-color: #c2c2c2;
  background-blend-mode: multiply;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${H4} {
    color: #fff;
    font-weight: 400;
  }
`;

export const Button = styled(CoreButton)`
  display: flex;
  align-items: center;
  margin: 0;
  height: 36px;
  width: 100%;

  background-color: ${({ theme }) => theme.plus.primary};

  :not([disabled]):hover {
    background-color: ${({ theme }) => theme.plus.primary};
    opacity: 0.9;
  }

  span {
    margin-right: 10px;
    font-weight: 700;
    ${getFont(0, 'compact')}
  }
`;

type Props = {
  pill?: Object
};

export const PillCard = ({ pill }: Props) => {
  if (!pill) return <Inner empty />;

  const linkProps = {
    as: LayerLink,
    href: pill.hasLanding
      ? `/pildoras/${pill.alias}`
      : pill.isOld
        ? `https://finect.com/apps/${pill.alias}-finectweb`
        : `${getSuperPartnerBaseURL()}/pills/es_ES/finect/default/${pill.alias}`,
    target: '_blank'
  };

  return (
    <Inner img={pill.img} {...linkProps}>
      <H4>{pill.title}</H4>
      <Button>
        <span>Realiza tu cálculo</span>
        <LongArrowRight size="28" color="white" />
      </Button>
    </Inner>
  );
};
